<template>
  <span class="logo" :class="'logo--' + kind" role="img" :aria-label="label"></span>
</template>

<script>
export default {
  name: 'SiteLogo',
  props: {
    site: { type: String, default: 'abaata' }
  },
  computed: {
    kind () {
      if (this.site === 'abaata' || this.site === 'amari') return this.site
      return 'pitsunda'
    },
    label () {
      return { abaata: 'Абаата Гагра', amari: 'Amari Hotel', pitsunda: 'Абаата Пицунда' }[this.kind]
    }
  }
}
</script>

<style scoped>
/* Фирменные SVG белые: закрашиваем их цветом текста (currentColor) через маску */
.logo {
  display: block;
  height: 64px;
  aspect-ratio: 320 / 125;
  background-color: currentColor;
  -webkit-mask: no-repeat left center / contain;
  mask: no-repeat left center / contain;
}
.logo--abaata {
  -webkit-mask-image: url('../assets/img/header/header__logo.svg');
  mask-image: url('../assets/img/header/header__logo.svg');
}
.logo--amari {
  height: 30px;
  aspect-ratio: 230 / 37;
  -webkit-mask-image: url('../assets/general/amari.svg');
  mask-image: url('../assets/general/amari.svg');
}
.logo--pitsunda {
  -webkit-mask-image: url('../assets/general/abaata.svg');
  mask-image: url('../assets/general/abaata.svg');
}
</style>
